/**
 * R2 - Centralized brand asset configuration
 * R4 - Single source of truth for all brand resources
 * 
 * All INBOCA logo variants hosted on Cloudinary.
 * Use `as const` for type safety and autocompletion.
 */

// Logo URL definitions
const LOGO_URLS = {
  full: {
    white: 'https://res.cloudinary.com/dphpfdsk3/image/upload/v1763993197/LOGO_djztth.png',
    transparent: 'https://res.cloudinary.com/dphpfdsk3/image/upload/v1763993441/LOGO_WB_que8va.png',
  },
  icon: {
    white: 'https://res.cloudinary.com/dphpfdsk3/image/upload/v1763993554/LOGO_IMG_mwydzi.png',
    transparent: 'https://res.cloudinary.com/dphpfdsk3/image/upload/v1763993555/LOGO_IMG_WB_gfdfpv.png',
  },
} as const;

// Favicon (icon + transparent for best compatibility)
export const FAVICON_URL = LOGO_URLS.icon.transparent;

// Export with semantic naming
export const BRAND_LOGOS = LOGO_URLS;

// Alt text for accessibility (R4)
export const LOGO_ALT_TEXT = 'INBOCA - Soluciones Corporativas' as const;
